/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Presentation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface BlockDto
 */
export interface BlockDto {
    /**
     * 
     * @type {string}
     * @memberof BlockDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockDto
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof BlockDto
     */
    order?: number;
}
/**
 * 
 * @export
 * @interface ContentAssessmentDto
 */
export interface ContentAssessmentDto {
    /**
     * 
     * @type {string}
     * @memberof ContentAssessmentDto
     */
    userQuestionnaireId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentAssessmentDto
     */
    assessmentState?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentAssessmentDto
     */
    score?: number;
    /**
     * 
     * @type {Array<UserQuestionDto>}
     * @memberof ContentAssessmentDto
     */
    questions?: Array<UserQuestionDto>;
}
/**
 * 
 * @export
 * @interface ContentWithIdDto
 */
export interface ContentWithIdDto {
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof ContentWithIdDto
     */
    blocks?: Array<BlockDto>;
    /**
     * 
     * @type {string}
     * @memberof ContentWithIdDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentWithIdDto
     */
    skillId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentWithIdDto
     */
    skillName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentWithIdDto
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentWithIdDto
     */
    assessmentStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentWithIdDto
     */
    score?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentWithIdDto
     */
    hasNext?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentWithIdDto
     */
    hasPrevious?: boolean;
}
/**
 * 
 * @export
 * @interface FindSingleSkillDto
 */
export interface FindSingleSkillDto {
    /**
     * 
     * @type {string}
     * @memberof FindSingleSkillDto
     */
    skillId?: string;
    /**
     * 
     * @type {string}
     * @memberof FindSingleSkillDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindSingleSkillDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindSingleSkillDto
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FindSingleSkillDto
     */
    score?: number;
}
/**
 * 
 * @export
 * @interface GetUserRoleListDto
 */
export interface GetUserRoleListDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserRoleListDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRoleListDto
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface PresentRoleDto
 */
export interface PresentRoleDto {
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    chosenDesignationId?: string;
    /**
     * 
     * @type {Array<RoleDesignationDto>}
     * @memberof PresentRoleDto
     */
    designations?: Array<RoleDesignationDto>;
    /**
     * 
     * @type {string}
     * @memberof PresentRoleDto
     */
    assessmentStatus?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PresentRoleDto
     */
    descriptions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PresentRoleDto
     */
    categories?: Array<string>;
}
/**
 * 
 * @export
 * @interface RequiredDesignationDto
 */
export interface RequiredDesignationDto {
    /**
     * 
     * @type {boolean}
     * @memberof RequiredDesignationDto
     */
    requiredForUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequiredDesignationDto
     */
    roleDesignationId?: string;
    /**
     * 
     * @type {string}
     * @memberof RequiredDesignationDto
     */
    roleDesignationName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequiredDesignationDto
     */
    roleDesignationDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof RequiredDesignationDto
     */
    levelLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RequiredDesignationDto
     */
    level?: number;
}
/**
 * 
 * @export
 * @interface RequiredRoleDto
 */
export interface RequiredRoleDto {
    /**
     * 
     * @type {string}
     * @memberof RequiredRoleDto
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof RequiredRoleDto
     */
    roleName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequiredRoleDto
     */
    roleDescription?: string;
    /**
     * 
     * @type {Array<RequiredDesignationDto>}
     * @memberof RequiredRoleDto
     */
    requiredDesignations?: Array<RequiredDesignationDto>;
}
/**
 * 
 * @export
 * @interface RoleDesignationDto
 */
export interface RoleDesignationDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDesignationDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleDesignationDto
     */
    level?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDesignationDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDesignationDto
     */
    description?: string;
    /**
     * 
     * @type {Array<SkillDto>}
     * @memberof RoleDesignationDto
     */
    skills?: Array<SkillDto>;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    chosenDesignationId?: string;
    /**
     * 
     * @type {Array<RoleDesignationDto>}
     * @memberof RoleDto
     */
    designations?: Array<RoleDesignationDto>;
}
/**
 * 
 * @export
 * @interface RoleSearchResultsDto
 */
export interface RoleSearchResultsDto {
    /**
     * 
     * @type {number}
     * @memberof RoleSearchResultsDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleSearchResultsDto
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<PresentRoleDto>}
     * @memberof RoleSearchResultsDto
     */
    results?: Array<PresentRoleDto>;
}
/**
 * 
 * @export
 * @interface SearchSkillDto
 */
export interface SearchSkillDto {
    /**
     * 
     * @type {string}
     * @memberof SearchSkillDto
     */
    skillId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSkillDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSkillDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSkillDto
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<RequiredRoleDto>}
     * @memberof SearchSkillDto
     */
    requiredRoles?: Array<RequiredRoleDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchSkillDto
     */
    ovarallScore?: number;
}
/**
 * 
 * @export
 * @interface SearchSkillResultDto
 */
export interface SearchSkillResultDto {
    /**
     * 
     * @type {number}
     * @memberof SearchSkillResultDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSkillResultDto
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<SearchSkillDto>}
     * @memberof SearchSkillResultDto
     */
    results?: Array<SearchSkillDto>;
}
/**
 * 
 * @export
 * @interface SkillDto
 */
export interface SkillDto {
    /**
     * 
     * @type {string}
     * @memberof SkillDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkillDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SkillDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SkillDto
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof SkillDto
     */
    level?: number;
    /**
     * 
     * @type {SkillLevelDto}
     * @memberof SkillDto
     */
    skillLevel?: SkillLevelDto;
}
/**
 * 
 * @export
 * @interface SkillLevelDto
 */
export interface SkillLevelDto {
    /**
     * 
     * @type {string}
     * @memberof SkillLevelDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SkillLevelDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SkillLevelDto
     */
    skillLevel?: number;
}
/**
 * 
 * @export
 * @interface TopicDto
 */
export interface TopicDto {
    /**
     * 
     * @type {string}
     * @memberof TopicDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TopicDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TopicDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TopicDto
     */
    assessmentState?: string;
    /**
     * 
     * @type {number}
     * @memberof TopicDto
     */
    score?: number;
}
/**
 * 
 * @export
 * @interface TopicLevelDto
 */
export interface TopicLevelDto {
    /**
     * 
     * @type {Array<TopicDto>}
     * @memberof TopicLevelDto
     */
    topics?: Array<TopicDto>;
    /**
     * 
     * @type {number}
     * @memberof TopicLevelDto
     */
    level?: number;
    /**
     * 
     * @type {string}
     * @memberof TopicLevelDto
     */
    levelLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TopicLevelDto
     */
    levelDesctiption?: string;
}
/**
 * 
 * @export
 * @interface UserAnswerDto
 */
export interface UserAnswerDto {
    /**
     * 
     * @type {string}
     * @memberof UserAnswerDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswerDto
     */
    answer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAnswerDto
     */
    answered?: boolean;
}
/**
 * 
 * @export
 * @interface UserQuestionDto
 */
export interface UserQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof UserQuestionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionDto
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionDto
     */
    assessmentState?: string;
    /**
     * 
     * @type {Array<UserAnswerDto>}
     * @memberof UserQuestionDto
     */
    answers?: Array<UserAnswerDto>;
}
/**
 * AssessmentApi - fetch parameter creator
 * @export
 */
export const AssessmentApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentContentIdGet(contentId: string, options: any = {}): FetchArgs {
            // verify required parameter 'contentId' is not null or undefined
            if (contentId === null || contentId === undefined) {
                throw new RequiredError('contentId','Required parameter contentId was null or undefined when calling assessmentContentIdGet.');
            }
            const localVarPath = `/Assessment/{contentId}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [userQuestionnaireId] 
         * @param {string} [answerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentPost(userQuestionnaireId?: string, answerId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Assessment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userQuestionnaireId !== undefined) {
                localVarQueryParameter['userQuestionnaireId'] = userQuestionnaireId;
            }

            if (answerId !== undefined) {
                localVarQueryParameter['answerId'] = answerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentApi - functional programming interface
 * @export
 */
export const AssessmentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentContentIdGet(contentId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContentAssessmentDto> {
            const localVarFetchArgs = AssessmentApiFetchParamCreator(configuration).assessmentContentIdGet(contentId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [userQuestionnaireId] 
         * @param {string} [answerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentPost(userQuestionnaireId?: string, answerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContentAssessmentDto> {
            const localVarFetchArgs = AssessmentApiFetchParamCreator(configuration).assessmentPost(userQuestionnaireId, answerId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AssessmentApi - factory interface
 * @export
 */
export const AssessmentApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentContentIdGet(contentId: string, options?: any) {
            return AssessmentApiFp(configuration).assessmentContentIdGet(contentId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [userQuestionnaireId] 
         * @param {string} [answerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentPost(userQuestionnaireId?: string, answerId?: string, options?: any) {
            return AssessmentApiFp(configuration).assessmentPost(userQuestionnaireId, answerId, options)(fetch, basePath);
        },
    };
};

/**
 * AssessmentApi - object-oriented interface
 * @export
 * @class AssessmentApi
 * @extends {BaseAPI}
 */
export class AssessmentApi extends BaseAPI {
    /**
     * 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public assessmentContentIdGet(contentId: string, options?: any) {
        return AssessmentApiFp(this.configuration).assessmentContentIdGet(contentId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [userQuestionnaireId] 
     * @param {string} [answerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public assessmentPost(userQuestionnaireId?: string, answerId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).assessmentPost(userQuestionnaireId, answerId, options)(this.fetch, this.basePath);
    }

}
/**
 * QuestionsApi - fetch parameter creator
 * @export
 */
export const QuestionsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [contentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsGet(contentId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Questions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentId !== undefined) {
                localVarQueryParameter['contentId'] = contentId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsApi - functional programming interface
 * @export
 */
export const QuestionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [contentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsGet(contentId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<UserQuestionDto>> {
            const localVarFetchArgs = QuestionsApiFetchParamCreator(configuration).questionsGet(contentId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * QuestionsApi - factory interface
 * @export
 */
export const QuestionsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [contentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsGet(contentId?: string, options?: any) {
            return QuestionsApiFp(configuration).questionsGet(contentId, options)(fetch, basePath);
        },
    };
};

/**
 * QuestionsApi - object-oriented interface
 * @export
 * @class QuestionsApi
 * @extends {BaseAPI}
 */
export class QuestionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [contentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public questionsGet(contentId?: string, options?: any) {
        return QuestionsApiFp(this.configuration).questionsGet(contentId, options)(this.fetch, this.basePath);
    }

}
/**
 * RoleApi - fetch parameter creator
 * @export
 */
export const RoleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleCategoriesGet(options: any = {}): FetchArgs {
            const localVarPath = `/Role/categories`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleNamesGet(options: any = {}): FetchArgs {
            const localVarPath = `/Role/names`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleOutlineGet(roleId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Role/outline`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSearchGet(search?: string, category?: string, pageSize?: number, page?: number, options: any = {}): FetchArgs {
            const localVarPath = `/Role/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [interests] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSuggestGet(interests?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Role/suggest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (interests !== undefined) {
                localVarQueryParameter['interests'] = interests;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleCategoriesGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleCategoriesGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleNamesGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GetUserRoleListDto>> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleNamesGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleOutlineGet(roleId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RoleDto> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleOutlineGet(roleId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSearchGet(search?: string, category?: string, pageSize?: number, page?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RoleSearchResultsDto> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleSearchGet(search, category, pageSize, page, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [interests] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSuggestGet(interests?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RoleDto>> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleSuggestGet(interests, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleCategoriesGet(options?: any) {
            return RoleApiFp(configuration).roleCategoriesGet(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleNamesGet(options?: any) {
            return RoleApiFp(configuration).roleNamesGet(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleOutlineGet(roleId?: string, options?: any) {
            return RoleApiFp(configuration).roleOutlineGet(roleId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSearchGet(search?: string, category?: string, pageSize?: number, page?: number, options?: any) {
            return RoleApiFp(configuration).roleSearchGet(search, category, pageSize, page, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [interests] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleSuggestGet(interests?: string, options?: any) {
            return RoleApiFp(configuration).roleSuggestGet(interests, options)(fetch, basePath);
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleCategoriesGet(options?: any) {
        return RoleApiFp(this.configuration).roleCategoriesGet(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleNamesGet(options?: any) {
        return RoleApiFp(this.configuration).roleNamesGet(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [roleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleOutlineGet(roleId?: string, options?: any) {
        return RoleApiFp(this.configuration).roleOutlineGet(roleId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [search] 
     * @param {string} [category] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleSearchGet(search?: string, category?: string, pageSize?: number, page?: number, options?: any) {
        return RoleApiFp(this.configuration).roleSearchGet(search, category, pageSize, page, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [interests] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleSuggestGet(interests?: string, options?: any) {
        return RoleApiFp(this.configuration).roleSuggestGet(interests, options)(this.fetch, this.basePath);
    }

}
/**
 * SkillApi - fetch parameter creator
 * @export
 */
export const SkillApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillCategoriesGet(options: any = {}): FetchArgs {
            const localVarPath = `/Skill/categories`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {string} [assessmentStatus] 
         * @param {boolean} [sortAscending] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSearchGet(search?: string, category?: string, roleId?: string, roleDesignationId?: string, assessmentStatus?: string, sortAscending?: boolean, pageSize?: number, page?: number, options: any = {}): FetchArgs {
            const localVarPath = `/Skill/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (roleDesignationId !== undefined) {
                localVarQueryParameter['roleDesignationId'] = roleDesignationId;
            }

            if (assessmentStatus !== undefined) {
                localVarQueryParameter['assessmentStatus'] = assessmentStatus;
            }

            if (sortAscending !== undefined) {
                localVarQueryParameter['sortAscending'] = sortAscending;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSkillIdGet(skillId: string, options: any = {}): FetchArgs {
            // verify required parameter 'skillId' is not null or undefined
            if (skillId === null || skillId === undefined) {
                throw new RequiredError('skillId','Required parameter skillId was null or undefined when calling skillSkillIdGet.');
            }
            const localVarPath = `/Skill/{skillId}`
                .replace(`{${"skillId"}}`, encodeURIComponent(String(skillId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSuggestGet(roleDesignationId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Skill/suggest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleDesignationId !== undefined) {
                localVarQueryParameter['roleDesignationId'] = roleDesignationId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillApi - functional programming interface
 * @export
 */
export const SkillApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillCategoriesGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = SkillApiFetchParamCreator(configuration).skillCategoriesGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {string} [assessmentStatus] 
         * @param {boolean} [sortAscending] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSearchGet(search?: string, category?: string, roleId?: string, roleDesignationId?: string, assessmentStatus?: string, sortAscending?: boolean, pageSize?: number, page?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchSkillResultDto> {
            const localVarFetchArgs = SkillApiFetchParamCreator(configuration).skillSearchGet(search, category, roleId, roleDesignationId, assessmentStatus, sortAscending, pageSize, page, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSkillIdGet(skillId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FindSingleSkillDto> {
            const localVarFetchArgs = SkillApiFetchParamCreator(configuration).skillSkillIdGet(skillId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSuggestGet(roleDesignationId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SkillDto>> {
            const localVarFetchArgs = SkillApiFetchParamCreator(configuration).skillSuggestGet(roleDesignationId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SkillApi - factory interface
 * @export
 */
export const SkillApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillCategoriesGet(options?: any) {
            return SkillApiFp(configuration).skillCategoriesGet(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [category] 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {string} [assessmentStatus] 
         * @param {boolean} [sortAscending] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSearchGet(search?: string, category?: string, roleId?: string, roleDesignationId?: string, assessmentStatus?: string, sortAscending?: boolean, pageSize?: number, page?: number, options?: any) {
            return SkillApiFp(configuration).skillSearchGet(search, category, roleId, roleDesignationId, assessmentStatus, sortAscending, pageSize, page, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSkillIdGet(skillId: string, options?: any) {
            return SkillApiFp(configuration).skillSkillIdGet(skillId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillSuggestGet(roleDesignationId?: string, options?: any) {
            return SkillApiFp(configuration).skillSuggestGet(roleDesignationId, options)(fetch, basePath);
        },
    };
};

/**
 * SkillApi - object-oriented interface
 * @export
 * @class SkillApi
 * @extends {BaseAPI}
 */
export class SkillApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillApi
     */
    public skillCategoriesGet(options?: any) {
        return SkillApiFp(this.configuration).skillCategoriesGet(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [search] 
     * @param {string} [category] 
     * @param {string} [roleId] 
     * @param {string} [roleDesignationId] 
     * @param {string} [assessmentStatus] 
     * @param {boolean} [sortAscending] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillApi
     */
    public skillSearchGet(search?: string, category?: string, roleId?: string, roleDesignationId?: string, assessmentStatus?: string, sortAscending?: boolean, pageSize?: number, page?: number, options?: any) {
        return SkillApiFp(this.configuration).skillSearchGet(search, category, roleId, roleDesignationId, assessmentStatus, sortAscending, pageSize, page, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} skillId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillApi
     */
    public skillSkillIdGet(skillId: string, options?: any) {
        return SkillApiFp(this.configuration).skillSkillIdGet(skillId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [roleDesignationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillApi
     */
    public skillSuggestGet(roleDesignationId?: string, options?: any) {
        return SkillApiFp(this.configuration).skillSuggestGet(roleDesignationId, options)(this.fetch, this.basePath);
    }

}
/**
 * TopicApi - fetch parameter creator
 * @export
 */
export const TopicApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicContentGet(topicId?: string, prompt?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Topic/content`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }

            if (prompt !== undefined) {
                localVarQueryParameter['prompt'] = prompt;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [contentId] 
         * @param {boolean} [next] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicNextGet(topicId?: string, contentId?: string, next?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/Topic/next`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }

            if (contentId !== undefined) {
                localVarQueryParameter['contentId'] = contentId;
            }

            if (next !== undefined) {
                localVarQueryParameter['next'] = next;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [skillId] 
         * @param {number} [level] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicSuggestGet(skillId?: string, level?: number, prompt?: string, options: any = {}): FetchArgs {
            const localVarPath = `/Topic/suggest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skillId !== undefined) {
                localVarQueryParameter['skillId'] = skillId;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (prompt !== undefined) {
                localVarQueryParameter['prompt'] = prompt;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TopicApi - functional programming interface
 * @export
 */
export const TopicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicContentGet(topicId?: string, prompt?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContentWithIdDto> {
            const localVarFetchArgs = TopicApiFetchParamCreator(configuration).topicContentGet(topicId, prompt, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [contentId] 
         * @param {boolean} [next] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicNextGet(topicId?: string, contentId?: string, next?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContentWithIdDto> {
            const localVarFetchArgs = TopicApiFetchParamCreator(configuration).topicNextGet(topicId, contentId, next, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [skillId] 
         * @param {number} [level] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicSuggestGet(skillId?: string, level?: number, prompt?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TopicLevelDto>> {
            const localVarFetchArgs = TopicApiFetchParamCreator(configuration).topicSuggestGet(skillId, level, prompt, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TopicApi - factory interface
 * @export
 */
export const TopicApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicContentGet(topicId?: string, prompt?: string, options?: any) {
            return TopicApiFp(configuration).topicContentGet(topicId, prompt, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [topicId] 
         * @param {string} [contentId] 
         * @param {boolean} [next] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicNextGet(topicId?: string, contentId?: string, next?: boolean, options?: any) {
            return TopicApiFp(configuration).topicNextGet(topicId, contentId, next, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [skillId] 
         * @param {number} [level] 
         * @param {string} [prompt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicSuggestGet(skillId?: string, level?: number, prompt?: string, options?: any) {
            return TopicApiFp(configuration).topicSuggestGet(skillId, level, prompt, options)(fetch, basePath);
        },
    };
};

/**
 * TopicApi - object-oriented interface
 * @export
 * @class TopicApi
 * @extends {BaseAPI}
 */
export class TopicApi extends BaseAPI {
    /**
     * 
     * @param {string} [topicId] 
     * @param {string} [prompt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public topicContentGet(topicId?: string, prompt?: string, options?: any) {
        return TopicApiFp(this.configuration).topicContentGet(topicId, prompt, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [topicId] 
     * @param {string} [contentId] 
     * @param {boolean} [next] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public topicNextGet(topicId?: string, contentId?: string, next?: boolean, options?: any) {
        return TopicApiFp(this.configuration).topicNextGet(topicId, contentId, next, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [skillId] 
     * @param {number} [level] 
     * @param {string} [prompt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public topicSuggestGet(skillId?: string, level?: number, prompt?: string, options?: any) {
        return TopicApiFp(this.configuration).topicSuggestGet(skillId, level, prompt, options)(this.fetch, this.basePath);
    }

}
/**
 * UserRoleApi - fetch parameter creator
 * @export
 */
export const UserRoleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolePost(roleId?: string, roleDesignationId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/UserRole`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (roleDesignationId !== undefined) {
                localVarQueryParameter['roleDesignationId'] = roleDesignationId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRoleApi - functional programming interface
 * @export
 */
export const UserRoleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolePost(roleId?: string, roleDesignationId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserRoleApiFetchParamCreator(configuration).userRolePost(roleId, roleDesignationId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserRoleApi - factory interface
 * @export
 */
export const UserRoleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [roleId] 
         * @param {string} [roleDesignationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolePost(roleId?: string, roleDesignationId?: string, options?: any) {
            return UserRoleApiFp(configuration).userRolePost(roleId, roleDesignationId, options)(fetch, basePath);
        },
    };
};

/**
 * UserRoleApi - object-oriented interface
 * @export
 * @class UserRoleApi
 * @extends {BaseAPI}
 */
export class UserRoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [roleId] 
     * @param {string} [roleDesignationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleApi
     */
    public userRolePost(roleId?: string, roleDesignationId?: string, options?: any) {
        return UserRoleApiFp(this.configuration).userRolePost(roleId, roleDesignationId, options)(this.fetch, this.basePath);
    }

}
